<template>
  <div>
      <Header></Header>
      <!-- <label class="verticalLabel left moduleTitle">ANNUAL REPORT 2020</label>
    <label class="verticalLabel right reportTitle">COMMERCIAL & CUSTOMER EXPERIENCE</label> -->
      <section class="commerecial_customer" data-scroll-container> 
        <div class="section section_one" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="image_parent">
                                    <div class="image_main image-reveal">
                                        <div class="revealer"></div>
                                        <img src="@/assets/images/custumer/SmartphonesWife2.png" alt="" class="img-fluid">
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="innerText flex-div" data-aos="fade-left">
                                    <h4>
                                        ZAIN BUSINESS:<br/>
                                        THE OPERATOR OF CHOICE<br/>
                                        FOR GOVERNMENT <br/>
                                        AND ENTERPRISES  <br/>
                                    </h4>
                                    <p class="desc">In 2020, Zain strengthened its position as the operator of choice for governments and enterprises of all sizes, across our 
                                        markets.The company made strategic investments in assets and innovative service platforms to address the evolving 
                                        needs of B2B customers in mobile, fixed, IoT, hosted managed solutions and managed security services.
                                    </p>
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="section section_three baharain" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                           <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                    <h4 class="text-uppercase">zain bahrain</h4>
                                </div>
                            <div class="main_content height-for-center">
                                 
                                <div class="container_grid">
                                   <div class="row first_row" data-scroll data-scroll-speed="3">
                                       <div class="col-md-6">
                                           <div class="main_card">
                                               <div class="card_custom first_card">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/baharain-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Zain Bahrain launched fiber 
                                                            based broadband offerings, 
                                                            with speeds up to 
                                                            500Mbps, to support and 
                                                            enhance customers’ digital 
                                                            transformation journey.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-6">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/baharain-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>The operator introduced a 
                                                            suite of fiber-based 
                                                            solutions to address the 
                                                            needs of SMEs in Bahrain.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   <div class="row second_row mt-30" data-scroll data-scroll-speed="-1">
                                       <div class="col-12">
                                           <div class="main_card card_three">
                                               <div class="card_custom ">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/baharain-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Launched a unified threat management 
                                                            service, in partnership with Fortinet. This is 
                                                            a cloud-based comprehensive security 
                                                            solution designed to increase network 
                                                            protection, security, and control through 
                                                            anti-virus, anti-malware protection, content 
                                                            filtering, firewall, Intrusion Detection 
                                                            System, Intrusion Protection System, and 
                                                            threat monitoring. 
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section_two kuwait" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner p-relative h-100">
                            <!-- <div class="section-title" >
                                <h5 data-aos="fade-left">COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">zain kuwait</h4>
                            </div>
                            <div class="main_section medium-width height-for-center">
                                <div class="row">
                                    <div class="col-md-6 p-relative left-section" >
                                       
                                        <div class="img_floting image-reveal">
                                            <div class="revealer"></div>
                                            <img src="@/assets/images/custumer/EdTGIudWoAExcWU.png" alt="" class="img-fluid">
                                        </div>
                                        <div class="text_float">
                                            <p data-aos="fade-left">Zain Kuwait began offering thermal camera services to its 
                                                corporate customers with great success. Running on 
                                                Zain’s network, these cameras can measure body 
                                                temperatures from a safe distance in less than a second. 
                                                The camera system also facilitates the recording of 
                                                temperatures of large groups of people, numbering up to 
                                                30 individuals at a time. The solution is also equipped with 
                                                artificial intelligence (AI), which allows for the identification 
                                                of individuals’ faces, and matches the images with past 
                                                recorded body temperatures. The matching function 
                                                works in scenarios where people are wearing face masks. 
                                                These cameras also function as CCTV surveillance 
                                                cameras that record footage around-the-clock.
                                            </p>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="col-md-6 right-section" >
                                        <div class="innerBox upperBox mb-4">
                                            <div class="box_container">
                                                <div class="innerImage image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/Zain_B2B_Classera.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="innerText">
                                                    <p data-aos="fade-left">The operator partnered with 
                                                        Classera to offer learning 
                                                        management solutions (LMS) 
                                                        to facilitate e-learning and 
                                                        support universities, schools, 
                                                        teachers, students, and 
                                                        families, to better cope with 
                                                        remote learning during the 
                                                        COVID-19 pandemic.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerBox bottomBox">
                                            <div class="box_container">
                                                <div class="innerImage image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/Zain_B2B_Classera-2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="innerText">
                                                    <p data-aos="fade-left">Zain live stream service was 
                                                    used to run shareholder 
                                                    assembly meetings for Zain 
                                                    and other companies, as an 
                                                    alternative platform to 
                                                    physical meetings. The 
                                                    solution supports capital 
                                                    market regulations on the 
                                                    organization of shareholder 
                                                    meetings, while keeping 
                                                    participants at a safe 
                                                    distance.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="section section_four sudan" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">zain sudan</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row" data-scroll data-scroll-speed="3">
                                       <div class="col-md-6">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/sudan-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>The Sudanese Petroleum 
                                                            Corporation (SPC) Project is 
                                                            a business connectivity 
                                                            solution providing fuel 
                                                            distributers and service 
                                                            stations with secure, private, 
                                                            and customized remote 
                                                            access to their HQ and to the 
                                                            Ministry of Petroleum using 
                                                            the Zain network.
                                                       </p>
                                                       <p>The project enables the 
                                                        Ministry and distribution 
                                                        companies to successfully 
                                                        monitor fuel distribution by 
                                                        providing secure and 
                                                        cost-effective connectivity to 
                                                        fuel stations.</p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-6">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/sudan-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>HECOOL is the first smart agriculture 
                                                            product provided by Zain Sudan, aiming to 
                                                            support farmers to increase productivity and 
                                                            decrease OPEX. HECOOL provides farmers 
                                                            with four indexes generated from high quality satellite images enabling them to 
                                                            monitor and analyze crop health, soil 
                                                            moisture, and green coverage.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   <div class="row second_row justify-content-center" data-scroll data-scroll-speed="4">
                                       <div class="col-md-8">
                                           <div class="main_card card_three">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/sudan-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>As part of Zain efforts to support innovative 
                                                            learning experiences in Sudan through 
                                                            information and communication 
                                                            technologies, Zain Sudan launched ZEES 
                                                            e-education management system, which 
                                                            provides a quality education platform for 
                                                            teachers and students.
                                                       </p>
                                                       <p>ZEES is a comprehensive, integrated, and 
                                                        advanced system for managing remote 
                                                        learning institutions that can be applied in 
                                                        universities, schools, institutes, and colleges. 
                                                        It is designed to raise the level of interaction 
                                                        between students, teachers, parents, and 
                                                        management. </p>
                                                        <p>ZEES l changed traditional administrative 
                                                        systems and educational activities within 
                                                        institutions, to an intelligent, interactive 
                                                        electronic system accessible from anywhere 
                                                        through the cloud.</p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- new added  -->
        <div class="section section_four saudia" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2" >
                                <h4 class="text-uppercase">ZAIN SAUDI ARABIA</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row">
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal"> 
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Zain KSA launched 
                                                            Samsung Knox, a multi layer mobile device security 
                                                            solution to address security 
                                                            concerns on Android.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Launched the “Teachers 
                                                            bundle”, a mobile 
                                                            broadband offer with a PC 
                                                            to support remote 
                                                            schooling.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card card_three">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>e-SIM launch in KSA for 
                                                            business customers, 
                                                            providing a contactless 
                                                            selling experience. E-SIM is 
                                                            now available for business 
                                                            customers in Kuwait, Saudi 
                                                            Arabia, Bahrain, and Jordan.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-4.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Zain KSA launched Fiber to-the-Business services, 
                                                            providing B2B customers 
                                                            with very high bandwidth 
                                                            internet connectivity over 
                                                            fiber.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>

                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-5.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Launched dedicated 
                                                            IP-VPN services over 5G by 
                                                            leveraging the ultra-fast 
                                                            Zain KSA 5G network to 
                                                            build data networks and 
                                                            connect customer 
                                                            headquarters, warehouses, 
                                                            branches, shops, etc., on a 
                                                            single network.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card card_three">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-6.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Launched Direct Internet 
                                                            Access (DIA) services over 
                                                            5G. DIA is a fixed-mobile 
                                                            substitution technology, 
                                                            where Zain utilizes its 
                                                            leading 5G network to 
                                                            provide B2B customers 
                                                            with high-speed dedicated 
                                                            internet connectivity.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-7.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Launched a managed 
                                                            router service providing 
                                                            customers with end-to end 
                                                            LAN-WAN service 
                                                            management, which 
                                                            includes bandwidth, 
                                                            internet connectivity and 
                                                            LAN devices.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card card_custom">
                                               <div>
                                                   <div class="img_floting image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-8.png" alt="" class="img-fluid">
                                                   </div> 
                                                   <div class="text_floting cardCotent">
                                                       <p>Zain launched a full suite 
                                                            of cloud services that range 
                                                            from IaaS to SaaS.
                                                       </p>
                                                       <p>The infrastructure offer 
                                                        includes elastic compute 
                                                        services, object storage 
                                                        services and server load 
                                                        balancer.</p>
                                                        <p>Zain offers telemedicine-as a-service, tele radiology-as a-service, thermal 
                                                        screening-as-a-service, and 
                                                        unified communications as-a- service</p>
                                                   </div>
                                                   <div class="clear"></div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="section section_four">
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div>
                            <div class="section-Text-Overlay">
                                <h4 class="text-uppercase">ZAIN SAUDI ARABIA</h4>
                            </div>
                            <div class="main_content">
                                <div class="container_grid">
                                   <div class="row first_row">
                                       <div class="col-6">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage">
                                                       <img src="@/assets/images/custumer/saudia-5.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>
                                                           Launched dedicated 
                                                            IP-VPN services over 5G by 
                                                            leveraging the ultra-fast 
                                                            Zain KSA 5G network to 
                                                            build data networks and 
                                                            connect customer 
                                                            headquarters, warehouses, 
                                                            branches, shops, etc., on a 
                                                            single network.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-6">
                                           <div class="main_card card_three">
                                               <div class="card_custom">
                                                   <div class="cardImage">
                                                       <img src="@/assets/images/custumer/saudia-6.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>
                                                            Launched Direct Internet 
                                                            Access (DIA) services over 
                                                            5G. DIA is a fixed-mobile 
                                                            substitution technology, 
                                                            where Zain utilizes its 
                                                            leading 5G network to 
                                                            provide B2B customers 
                                                            with high-speed dedicated 
                                                            internet connectivity.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-6">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage">
                                                       <img src="@/assets/images/custumer/saudia-7.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>
                                                            Launched a managed 
                                                            router service providing 
                                                            customers with end-to end 
                                                            LAN-WAN service 
                                                            management, which 
                                                            includes bandwidth, 
                                                            internet connectivity and 
                                                            LAN devices.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-6">
                                           <div class="main_card first_card">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage">
                                                       <img src="@/assets/images/custumer/saudia-8.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>
                                                           Zain launched a full suite 
                                                            of cloud services that range 
                                                            from IaaS to SaaS.
                                                       </p>
                                                       <p>The infrastructure offer 
                                                        includes elastic compute 
                                                        services, object storage 
                                                        services and server load 
                                                        balancer.</p>
                                                        <p>Zain offers telemedicine-as a-service, tele radiology-as a-service, thermal 
                                                        screening-as-a-service, and 
                                                        unified communicationsas-a- service</p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        

        <!-- jordAN  -->
        <div class="section section_four jordan" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">ZAIN JORDAN</h4>
                            </div>
                            <div class="main_content medium-width height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row align-itoms-md-start align-itoms-center" data-scroll data-scroll-speed="5">
                                       <div class="col-md-6 mx-auto">
                                           <div class="main_card first_card">
                                               <div class="img-">
                                                   <div class="img_floting cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/jordan-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent text_float">
                                                       <p>Zain Jordan launched integrated fixed mobile ICT offers for SMEs, delivering on the 
                                                            promise of the offer of a one-stop-shop for 
                                                            SoHo’s and SMEs.
                                                       </p>
                                                       
                                                   </div>
                                                   <div class="clear"></div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-6 mx-auto">
                                           <div class="main_card ">
                                               <div class="">
                                                   <div class="img_floting cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/jordan-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent text_float">
                                                       <p>Zain Business believes that an innovative approach and flexibility are 
                                                            enablers of business growth. Expanding our portfolio to include cloud and 
                                                            security solutions bundled with our voice and connectivity services, Zain 
                                                            Business has developed solutions that support Zain customers in managing 
                                                            the complexity of business communication. In 2020, Zain Jordan launched a 
                                                            full suite of cloud and security services in collaboration with Zain Data Park 
                                                            and hosted directly from the Bunker including WAF, DDOS and IaaS 
                                                            solutions.
                                                       </p>
                                                       
                                                   </div>
                                                   <div class="clear"></div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <!-- iraqq  -->
        <div class="section section_four iraq" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="3">
                                <h4 class="text-uppercase">ZAIN IRAQ</h4>
                            </div>
                            <div class="main_content small-width height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row">
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="4">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Zain Iraq launched location based SMS service enabling 
                                                            businesses to promote their 
                                                            products to an audience 
                                                            within a certain 
                                                            geographical location.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="3">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>The operator’s two-way 
                                                            SMS service enables 
                                                            companies to engage better 
                                                            with their customers, by 
                                                            establishing meaningful 
                                                            interactions with their 
                                                            audiences.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="1">
                                           <div class="main_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Zain Iraq launched a new 
                                                            mobile broadband offer, 
                                                            targeting business and 
                                                            government institutions 
                                                            in Iraq.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="1">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-4.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>Through the operator’s 
                                                            partner Awal Telecom, Zain 
                                                            Iraq B2B began providing 
                                                            SME/large enterprises with 
                                                            Microsoft 365 products to 
                                                            run their businesses 
                                                            effectively.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- dif  -->
        <div class="section section_four" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay right--50" data-scroll data-scroll-speed="-6">
                                <h4 class="text-uppercase small">2020 A YEAR OF REVENUE GROWTH FOR ZAIN BUSINESS</h4>
                            </div>
                            <div class="main_content height-for-center large-width ">
                                <div class="container_grid">
                                   <div class="row first_row">
                                       <div class="col-md-8 mx-md-auto mx-3" data-scroll data-scroll-speed="1">
                                           <div class="desc">
                                               <p>Despite the slowdown in economic activity caused 
                                                by the COVID-19 health crisis and government mitigation 
                                                policies, Zain’s B2B business unit delivered robust revenue 
                                                growth in 2020.</p>
                                                <p>This was driven by both the expansion of the customer base 
                                                including SoHo’s and SMEs accounts, large corporations and 
                                                Government accounts, as well as increased penetration of 
                                                non-mobile products, with a focus on fixed services.</p>
                                                <p>Another area of growth was IoT, where Zain acquired 
                                                hundreds of thousands of new smart meter contracts 
                                                in Jordan, Iraq, and Bahrain, consolidating our market 
                                                leadership position in the smart meter sector.</p>
                                                <p>ZAIN B2B teams across operations worked alongside public 
                                                health authorities to implement awareness and information 
                                                campaigns, and deployed technology to track COVID-19 
                                                infections and quarantine, joining efforts with governments 
                                                to mitigate the effects of the pandemic.</p>
                                                <p>Customers were top of our minds in the development of COVID-19 response plans. Zain operations implemented 
                                                the following support initiatives to help B2B customers mitigate the impact of the pandemic, and the associated 
                                                business disruption:</p>
                                           </div>
                                       </div>
                                       <div class="col-md-4 mx-md-auto mx-3">
                                            <div class="">
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/zain-businees.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_floting">
                                                    <p>In Kuwait, Zain’s role has 
                                                        ranged from equipping 
                                                        first responders and 
                                                        quarantine centers with 
                                                        the connections they 
                                                        need, to a full-fledged 
                                                        solution to monitor 
                                                        government self quarantine directives. 
                                                        The latter was achieved 
                                                        through the creation of 
                                                        a mobile application (Shlonik) internally and 
                                                        equipping the users with smart bracelets. These 
                                                        efforts have helped curb the spread of the virus and 
                                                        protecting the public.
                                                    </p>
                                                </div>
                                            </div>
                                       </div>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div  class="section section_revenue" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            <div class="main_content height-for-center">
                                <div class="container_grid">
                                   <div class="row justify-content-center col-gap-10">
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>Stock Delivery</h5>
                                               <p>Home/Office delivery of SIMs and 
                                                Devices to B2B Customers, securing 
                                                business continuity despite curfews 
                                                and movement restrictions</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>Free Microsoft Teams</h5>
                                               <p>HExclusive offer of free 
                                                MS Teams licenses 
                                                (limited time) offered to 
                                                support business 
                                                customers in managing 
                                                & communicating their 
                                                employees</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>Cisco Webex</h5>
                                               <p>Zain Business customers offered free 
                                                of charge 3 months of Webex free 
                                                of charge</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>Free Microsoft O365</h5>
                                               <p>Exclusive offer of free 
                                                MS Office 365 licenses  
                                                (limited time) offered to 
                                                support business </p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>Free Minutes</h5>
                                               <p>Supported the business clients during the pandemic with free voice minutes</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3">
                                           <div class="revenue-box">
                                               <h5>Payment Facilitation</h5>
                                               <p>Extending the bill 
                                                payment period without 
                                                deactivating the lines for 
                                                most of the accounts. 
                                                Design payment plans to 
                                                support customer’s 
                                                cashflows</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>Free Data Package</h5>
                                               <p>Free date package offered during the pandemic to business customers</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3">
                                           <div class="revenue-box">
                                               <h5>Work from Home Solution</h5>
                                               <p>Introduced high-bandwidth connectivity solutions to support remote workers</p>
                                           </div>
                                       </div>
                                      
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">DIGITALIZATION TO BETTER<br>SERVE B2B CUSTOMERS</h4>
                            </div>
                            <div class="main_content height-for-center">
                                
                                <p class="mb-40">The ecosystem of Zain Partners, who like most businesses were affected by the slowdown in the economy, were supported 
                                by specific cash lines, which helped them maintain their sales and service capabilities, staffing levels, and the high standards 
                                of service to Zain customers.
                                In pursuing the full digitalization of our operations, 2020 has seen the implementation of important milestones.</p>
                                <div class="row">
                                    <div class="col-md-5 p-relative left-section">
                                       
                                        <div class="img_floting image-reveal">
                                            <div class="revealer"></div>
                                            <img src="@/assets/images/custumer/digitalized-1.png" alt="" class="img-fluid">
                                        </div>
                                        <div class="text_float">
                                            <p data-aos="fade-left">SME app in Kuwait - As part of its strategic focus on the 
                                                SME segment, Zain Kuwait was the first and only telecom 
                                                operator in Kuwait to offer a comprehensive digital 
                                                platform. This application enables SME customers 
                                                to access Zain Business’ wide range of digital services 
                                                through the click of a button, without the need for 
                                                physical presence.
                                            </p>
                                            <p>This advanced solution received wide acceptance from 
                                            the market, as over 1,000 companies are registered on 
                                            the application and are using it actively. </p>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="col-md-7 right-section">
                                        <div class="innerBox upperBox">
                                            <div class="box_container digital">
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/digitalized-2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p data-aos="fade-left">Digital lead generation - 
                                                        all Zain operations enable 
                                                        potential customers to 
                                                        request service quotes, sales 
                                                        meetings, and product 
                                                        information, via social media. 
                                                        Potential customers for each 
                                                        Zain service line are targeted 
                                                        with relevant product 
                                                        information based on 
                                                        their profile.
                                                    </p>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                        <div class="innerBox bottomBox">
                                            <div class="box_container">
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/digitalized-3.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p data-aos="fade-left">Digital contract – Zain KSA 
                                                    introduced the full 
                                                    digitalization of its contract 
                                                    process by dematerializing 
                                                    contracts while securing the 
                                                    transaction end-to-end 
                                                    through government 
                                                    database integration 
                                                    and OTP procedures to 
                                                    authenticate signing parties.</p>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section brand" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">PROMOTING THE ZAIN BUSINESS BRAND</h4>
                            </div>
                            <div class="main_content height-for-center">
                                
                                <p class="mb-40">The ecosystem of Zain Partners, who like most businesses were affected by the slowdown in the economy, were supported 
                                by specific cash lines, which helped them maintain their sales and service capabilities, staffing levels, and the high standards 
                                of service to Zain customers. <br>
                                In pursuing the full digitalization of our operations, 2020 has seen the implementation of important milestones.</p>
                                <div class="row">
                                    <div class="col-sm-6 p-relative left-section">
                                       
                                        <div class="img_floting image-reveal">
                                            <div class="revealer"></div>
                                            <img src="@/assets/images/custumer/zain-brand.png" alt="" class="img-fluid">
                                        </div>
                                        <div class="text_float">
                                            <p data-aos="fade-left">Zain Kuwait was the strategic sponsor of Kuwait’s biggest 
                                                technology expo: Kuwait Tech Expo 2020. Zain’s strategic 
                                                support of this event affirms the company’s commitment 
                                                to being present at the various activities and programs that 
                                                contribute to Kuwait’s digital transformation journey. Large 
                                                global and local companies from the tech and telecom 
                                                sectors participated in the expo, as well as numerous 
                                                government entities, and was attended by over 25,000 
                                                attendees.
                                            </p>
                                            <p data-aos="fade-left">Through its futuristic booth at the event, Zain showcased its 
                                            capabilities as an active partner in empowering a smart life, 
                                            a safe community, and an efficient business sector by 
                                            offering the most advanced digital services and solutions.</p>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="col-sm-6 right-section">
                                        <div class="innerBox upperBox">
                                            <div class="box_container">
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/zain-brand-2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p data-aos="fade-left">Zain KSA showcased its business solutions at the Saudi IoT 
                                                        event held in March 2020 in Riyadh. Through “Zain 
                                                        Business,” the Zain KSA team presented state-of-the-art 
                                                        technologies, IoT, and smart city solutions. Additionally, 
                                                        showcased 5G network connectivity packages 
                                                        encompassing IoT bundles and connectivity options and 
                                                        applications for M2M devices to enable managing and 
                                                        integrating businesses throughout various sectors. These 
                                                        included, transportation, logistics, healthcare, energy, 
                                                        facilities management, general services, retail, and more. 
                                                    </p>
                                                    <p data-aos="fade-left">Moreover, Zain KSA presented “Zain Cloud” for businesses 
                                                    and SMEs, as well as drone applications via “Zain Drone,” 
                                                    where data collection and analysis services utilize AI 
                                                    analysis and cloud network technologies.
                                                    </p>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- dif -->

        <!-- new added  -->
        <!-- Muddusar Last Sections -->
        <div class="section last_seven text" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase small">ZAIN DATA PARK- DELIVERING HOSTED<br/>MANAGED AND SECURITY SERVICES</h4>
                            </div>
                            <div data-scroll data-scroll-speed="2">
                                
                                    <div class="main_content height-for-center">
                                        <div class="row custom_container">
                                            <div class="col-md-12">
                                                <div class="main_content">
                                                    <div class="text_float">
                                                        <p>Zain Data Park (ZDP), a new company playing a critical 
                                                                role in Zain’s journey to become a digital service provider 
                                                                was launched in Kuwait and Jordan. ZDP is responsible for 
                                                                the hosted managed and security service portfolios, which 
                                                                are available to Zain B2B customers through Zain 
                                                                operating companies. Our sales teams, supported by 
                                                                solutions architects, design integrated solutions with LAN/
                                                                WAN data connectivity, data storage, data transformation 
                                                                and data security.
                                                        </p>
                                                        <p>ZDP is a key component in Zain’s B2B strategy to become 
                                                            an integrated ICT player, and address customer needs to 
                                                            transport, transform, store and secure data, across Zain 
                                                            markets.
                                                            Leveraging on Zain’s regional datacenter network, which 
                                                            includes the Bunker – the only military nuclear grade 
                                                            datacenter in the Middle East, ZDP’s hosted managed 
                                                            services portfolio includes a wide range of cloud services, 
                                                            from virtual machines to virtual private datacenter 
                                                            services, which can be implemented in a variety 
                                                            of scenarios such as on-premise, from a Zain datacenter, 
                                                            or in hybrid set-ups. 
                                                        </p>
                                                        <p>With the data management capabilities of ZDP, our service 
                                                            offerings include disaster recovery services, where our 
                                                            solution architects work together with Zain customer CTOs 
                                                            and CIOs to implement data resilience strategies to deliver 
                                                            high availability solutions for critical corporate data and 
                                                            systems.
                                                            ZDP is expanding its services from the infrastructure layer – 
                                                            IaaS to the Software-as-a-Service layer, with an expanding 
                                                            offer that already includes Video Surveillance-as-a-Service, 
                                                            and Banking-as-a-Service.
                                                        </p>
                                                        <p>The security portfolio is organized in three pillars: Risk 
                                                            assessment, risk prevention, and risk management. Our 
                                                            security consultants can identify security risks and vulnerabilities in government and corporates through 
                                                            auditing and intrusion test methodologies. They can then 
                                                            mitigate risks through security policy design, technology 
                                                            deployment, and management practices.
                                                            ZDP also operates the Zain Security Operation Center, from 
                                                            where Zain manages the security platforms and policies for 
                                                            its corporate and government customers.
                                                            Hosted managed services and security solutions from ZDP 
                                                            are already integrated with Zain Kuwait’s and Zain Jordan’s 
                                                            B2B portfolio, and these services are being deployed in 
                                                            some of the largest organizations in both countries. Zain has 
                                                            ambitious plans to extend ZDP’s footprint and compelling 
                                                            service offering across the region.
                                                        </p>
                                                    </div>
                                                    <div class="clear"></div>
                                                </div>
                                            </div>
                                            <!-- <div class="col-md-6">
                                                <div class="main_content">
                                                    <div class="text_float">
                                                        <div class="headingOne">
                                                            <h4 class="font-weight-bold">Zain Kuwait Datacenter</h4>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark1.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark2.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark3.png" alt="" class="img-fluid">
                                                            </div>
                                                        </div>
                                                        <p>
                                                            With the data management capabilities of ZDP, our service 
                                                            offerings include disaster recovery services, where our 
                                                            solution architects work together with Zain customer CTOs 
                                                            and CIOs to implement data resilience strategies to deliver 
                                                            high availability solutions for critical corporate data and 
                                                            systems.
                                                            ZDP is expanding its services from the infrastructure layer – 
                                                            IaaS to the Software-as-a-Service layer, with an expanding 
                                                            offer that already includes Video Surveillance-as-a-Service, 
                                                            and Banking-as-a-Service.<br/>
                                                            The security portfolio is organized in three pillars: Risk 
                                                            assessment, risk prevention, and risk management. Our 
                                                            security consultants can identify security risks and vulnerabilities in government and corporates through 
                                                            auditing and intrusion test methodologies. They can then 
                                                            mitigate risks through security policy design, technology 
                                                            deployment, and management practices.
                                                            ZDP also operates the Zain Security Operation Center, from 
                                                            where Zain manages the security platforms and policies for 
                                                            its corporate and government customers.
                                                            Hosted managed services and security solutions from ZDP 
                                                            are already integrated with Zain Kuwait’s and Zain Jordan’s 
                                                            B2B portfolio, and these services are being deployed in 
                                                            some of the largest organizations in both countries. Zain has 
                                                            ambitious plans to extend ZDP’s footprint and compelling 
                                                            service offering across the region.
                                                        </p>
                                                        <div class="headingOne">
                                                            <h4 class="font-weight-bold">Zain Jordan Datacenter</h4>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark4.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark5.png" alt="" class="img-fluid">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                            
                                        </div>
                                        
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_seven images-sec" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            
                            <div>
                                
                                    <div class="main_content height-for-center">
                                        <div class="row custom_container">
                                            
                                            <div class="col-lg-5 col-sm-6">
                                                
                                                    <div class="text_float">
                                                        <div class="headingOne">
                                                            <h4 class="font-weight-bold">Zain Kuwait Datacenter</h4>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark1.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark2.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark3.png" alt="" class="img-fluid">
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                    </div>
                                                
                                            </div>
                                            <div class="col-lg-5 col-sm-6">
                                                
                                                    <div class="text_float">
                                                        <div class="headingOne">
                                                            <h4 class="font-weight-bold">Zain Jordan Datacenter</h4>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark4.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark5.png" alt="" class="img-fluid">
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_six" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="-3">
                                <h4 class="text-uppercase small">NXN- DELIVERING SMART AND DIGITAL SERVICES</h4>
                            </div>
                            <div data-scroll data-scroll-speed="2">
                                <div class="main_content height-for-center">
                                    <div class="container_grid">
                                        <div class="row first_row align-items-center" data-scroll data-scroll-speed="-1">
                                            <div class="col-md-7">
                                                
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/NXN2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p>NXN is Zain’s smart and digital services arm, driving the 
                                                        development of Zain’s digital products and big data 
                                                        offerings. NXN has prioritized the development of smart 
                                                        security, digital healthcare, asset tracking and smart cities/
                                                        district solutions.
                                                        NXN smart security-as-a-service is a state-of-the-art, 
                                                        end-to-end service that enables businesses to protect their 
                                                        people, assets, and facilities, while featuring advanced video 
                                                        surveillance management and analytics capabilities that 
                                                        cater to evolving surveillance needs. NXN offers a unique, 
                                                        cost effective and innovative digital security service that 
                                                        seamlessly functions with the highest level of IoT 
                                                        integration, automation, intelligence, control, and simplicity. 
                                                        It blends video surveillance, video artificial intelligence, 
                                                        smart video analytics, and incident management within one 
                                                        solution, in a pay-per-use pricing model.
                                                    </p>
                                                </div>
                                                <div class="clear"></div>
                                                    
                                            </div>
                                            <div class="col-md-5">

                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                        <img src="@/assets/images/custumer/NXN4.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p>NXN is one of the leading companies in Gartner’s Hype 
                                                    Cycle for smart city technologies and solutions 2020, where 
                                                    it was recognized as a leading vendor across five categories: 
                                                    city operations center; smart city-as-a-service; data 
                                                    exchange; greenfield smart city framework; and smart city 
                                                    framework. This showcased the key elements of NXN’s 
                                                    value proposition.</p>
                                                </div>
                                                <div class="clear"></div>
                                                    
                                            </div>
                                        </div>
                                        <div class="row second_row justify-content-center" data-scroll data-scroll-speed="-1">
                                            <div class="col-md-12">
                                                <div class="main_card card_three">
                                                    <div class="card_custom">
                                                        <div class="cardImage image-reveal">
                                                            <div class="revealer"></div>
                                                           <img src="@/assets/images/custumer/NXN1.png" alt="" class="img-fluid">
                                                        </div>
                                                        <div class="cardCotent">
                                                            <p>The digital healthcare solution from NXN is a 
                                                                comprehensive platform of services for the healthcare 
                                                                cluster to manage the patient journey end-to-end, from 
                                                                medical appointments through the teleconsultation digital 
                                                                platform, prescription management, and electronic medical 
                                                                records.
                                                                NXN was present at the Kuwait Tech event in February, 
                                                                with its remote patient monitoring solution, one of NXN 
                                                                services in the healthcare vertical. 
                                                                NXN demonstration of the remote patient monitoring 
                                                                solution to Zain’s Vice-Chairman and Group CEO at Kuwait 
                                                                Tech.
                                                                NXN has developed a unique and powerful advanced 
                                                                analytics service, allowing it to help customers design, 
                                                                transform, and run intelligent operations leveraging AI and 
                                                                embedded analytics. NXN advanced analytics can deploy 
                                                                business intelligence to support any type of operation, 
                                                                process, or customer interaction as it happens.
                                                                NXN advanced analytics seamlessly integrates data sources 
                                                                from disparate systems allowing the creation of AI powered, cross-functional, embedded data insights. We 
                                                                make it easy for customers to combine business and data 
                                                                strategy, data science and technology, in order for the 
                                                                customer organization to become more agile, efficient, and profitable.
                                                                NXN digital capabilities were recognized by tahawultech.
                                                                com in the “Future Enterprise Awards 2020”, as the winner 
                                                                of “Smart cities solutions provider of the year”.
                                                            </p>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_five" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">BRANDING AND ADVERTISING</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row custom_container" data-scroll data-scroll-speed="3">
                                    <div class="col-md-12">
                                        <div class="main_content mt-20">
                                            <div class="img_mxWidth img_floting image-reveal">
                                                <div class="reveal"></div>
                                                <img src="@/assets/images/custumer/boardImage.png" alt="" class="img-fluid">
                                            </div>
                                            <div class="text_float">
                                                <div class="text-title">
                                                    <h4 class="text-center font-weight-bold">A BRAND THAT CAPTURES THE IMAGINATION OF THE ENTIRE REGION</h4>
                                                </div>
                                                <p>
                                                      Throughout 2020, Zain Group focused on safeguarding and enhancing the company’s brand position as the most powerful and loved telecom icon in the region. Zain initiated awareness and tactical campaigns across its markets aimed at continuing the company’s transformation into a leading digital lifestyle brand, and helping customers keep up with the rapidly changing world. This activity helped reinforce Zain’s standing as being more than a mere telecom provider. 
                                                     Zain’s COVID-19 related digital innovation, corporate sustainability programs, and eye-catching marketing and social media campaigns captured the region’s imagination.<br/>13 years after the Zain brand launch in 2007, its valuation has consistently exceeded US$ 2 billion with the 2020 valuation increasing 9.9% to more than US$ 2.55 billion, according to the BrandFinance 2020 Global Telecom and Middle East brands report. This valuation and brand rating of AA maintains Zain’s unrivaled position as the number one home grown brand from Kuwait. 
                                                    This remarkable valuation some 13 years after the brand’s introduction is testament to the investment Zain has made in this area and more importantly the quality mobile and data services that the brand represents. We continue to develop this valuable brand equity by investing in our operations, network, and customer experience.
                                                </p>
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_four" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase small">DIGITAL TRANSFORMATION TO LESSEN<br/> IMPACT OF COVID-19</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row custom_container" data-scroll data-scroll-speed="3">
                                    <div class="col-md-12">
                                        <div class="main_content ">
                                            <div class="img_floting image-reveal">
                                                <div class="reveal"></div>
                                                <img src="@/assets/images/custumer/digitalTransformation.png" alt="" class="img-fluid">
                                            </div>
                                            <div class="text_float">
                                                <p>Since March 2020, Zain has been under mission-critical conditions as all operations have been focused on providing connectivity during the lockdown to minimize the impact of COVID-19 on socio-economic development. At the same time, Zain has doubled down on digital transformation to better serve businesses, governments, and societies, granting increased digital access to essential medical, commercial, and financial services.<br/>
                                                      The company has also focused on enhancing its entire network to offer the latest technology and digital services across its operations, developments that are positively impacting brand recognition and customer experience at every touch point they deal with Zain, whether they be individuals, enterprises or government bodies. These investments in nascent technologies and network capabilities including 5G positions Zain to be able to offer compelling products and service that extend beyond telecom into a vast array of digital services, content, entertainment, wearables, home automation, health and fitness as well as smart cities and drones. Over the past 12 months, Zain has invested approximately US$1 billion in expanding, upgrading, and rolling out 4G and 5G networks across its footprint, successfully rolling out 5G services in Kuwait, Saudi Arabia, and Bahrain. Zain Saudi Arabia’s 5G rollout remains the largest in the MENA region and the fourth largest globally. The campaign celebrating these historic milestones helped place Kuwait, Saudi Arabia and Bahrain on the global 5G telecom map, embodying our ethos of leveraging new opportunities. 
                                                </p>
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_three" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase small">SUPPORTING THE REGIONAL STARTUP ECOSYSTEM</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="main_text_wrapper"  data-scroll data-scroll-speed="2">
                                            <p>Zain recognizes that now more than ever, the entrepreneur 
                                            ecosystem needs to grow as the region requires the 
                                            economic diversification that arises from the ensuing 
                                            innovations. Accordingly, the company is focused 
                                            on numerous digital innovation and startup initiatives 
                                            across operations.</p>    
                                            <p>The company’s digital partnership with the MIT Enterprise 
                                            Forum Pan Arab Competition since 2015 has evolved 
                                            to become an annual occurrence that is awaited by thous
                                            ands of young Arab entrepreneurs, who see it as a platform 
                                            to showcase, test and develop their creative and innovative 
                                            ideas. We have supported this competition in the firm belief 
                                            that today’s innovators are tomorrow’s differentiators. </p>
                                            <p>Through this partnership, we look forward to encouraging 
                                            opportunities that enhance the power of innovation through 
                                            building up our future entrepreneurs and making the world 
                                            a better place. Furthermore, supporting such events aligns 
                                            perfectly to Zain’s aspirations of becoming a leading digital 
                                            lifestyle operator.</p>
                                            <p>The Zain Innovation Center (ZINC) in Kuwait and Jordan 
                                            are vibrant co-working hubs geared towards encouraging 
                                            young minds to think and act creatively in an open and 
                                            supportive environment. The goal of these centers is 
                                            to create a conducive atmosphere for entrepreneurs 
                                            to generate new ideas and develop them into viable 
                                            opportunities.</p>
                                            <p>In January 2020, Zain Kuwait completed its fifth edition
                                            of its Zain Great Idea (ZGI) tech startup accelerator program. 
                                            The conclusion came during the company’s Zain Demo Day 
                                            event, under which Zain’s 11 entrepreneurs met Kuwait’s 
                                            investment community. Zain Jordan’s ‘Al-Mubadara’ 
                                            competition saw six startups win prizes in a local 
                                            competition and go on to participate in the MIT Enterprise 
                                            Forum Pan Arab Competition, with one of these startups, 
                                            Draw It, being awarded first prize in the Ideas track. Draw It 
                                            is a tool that allows users to express their emotions through 
                                            the guided drawings of the human figure.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_two" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">AWARDS</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row custom_container">
                                    <div class="col-md-12" data-scroll data-scroll-speed="2">
                                        <div class="main_card">
                                            <div class="card_image image-reveal">
                                                <div class="image-reveal"></div>
                                                <img src="@/assets/images/custumer/AWARDS.png" alt="" class="img-fluid">
                                            </div>
                                            <div class="card_text ml-3">
                                                <p>Our brand grew from strength-to-strength in 2020, 
                                                    continuing to set high standards, ensuring our customers, 
                                                    stakeholders and employees had the best experience 
                                                    with Zain. <br/>
                                                    Most distinct was Zain’s categorization as the region’s 
                                                    highest ranked telecom group and only company from 
                                                    Kuwait in Forbes magazine’s The World’s Best Employers 
                                                    list for 2020. The list also saw Zain ranked fourth best 
                                                    employer across all industries in the Middle East.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-20" data-scroll data-scroll-speed="1">
                                        <p>
                                            Zain also won the ‘Best Brand’ at the 2020 Telecoms World 
                                            Awards Middle East, marking a record seventh consecutive year that Zain has won this award, having also been 
                                            recognized as the ‘Best Telecom Operator’ across the MENA 
                                            region on numerous occasions over the years.<br/>
                                            Zain Saudi Arabia’s 5G network won three Telecom Review 
                                            Excellence Awards, being recognized in three separate 
                                            categories for ‘Best 5G User Growth’, ‘Best Cloud Provider’, 
                                            and ‘Best 5G Infrastructure Deployment’.
                                            In December, Zain received six creativity awards at the Arab 
                                            Media Forum’s eighth Creativity Awards, which recognizes 
                                            creativity by Kuwaiti organizations - in three categories: 
                                            Television commercial Creativity, PR Creativity and Best 
                                            Government App. Four awards came under the TV 
                                            Commercial Creativity category for its most celebrated 
                                            TVCs of the year: Ramadan TVC, National Celebrations 
                                            TVC, Eid TVC, and its TVC on the heroic role of mothers 
                                            during the pandemic. Zain also received an award in the 
                                            Best Government App category for its ‘Shlonik’ app, which 
                                            the company developed during the pandemic along with the 
                                            Ministry of Health and the Central Agency for Information 
                                            Technology (CAIT). Additionally, Zain’s flagship operation 
                                            in Kuwait received the PR Creativity award.<br/>
                                            Across our footprint, all of our operations were recognized 
                                            with awards for achievements in marketing, sustainability 
                                            initiatives or for the introduction of innovative new services. 
                                        </p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section lastSection" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">SOCIAL MEDIA</h4>
                            </div>
                            <div class="main_content height-for-center large-width">
                                <div class="row" data-scroll data-scroll-speed="2">
                                    <div class="col-md-6">
                                        <p>Zain’s strategy of promoting its brand and activities 
                                            across its markets and the wider region through social 
                                            media channels saw an impressive increase in the number 
                                            of followers, comments and views across all social 
                                            media channels. <br/>
                                            Every Ramadan, Zain seeks to present a new message that 
                                            touches upon the most relevant issues in life in its television 
                                            commercials as the region’s Ramadan audience keenly 
                                            awaits Zain’s annual campaigns. The 2020 Zain Ramadan 
                                            commercial immediately amassed significant interest across 
                                            social media platforms, with the 2.35 minute-long content 
                                            having exceeded 42 million YouTube views to date. The Zain 
                                            Ramadan 2020 Eid commercial, ‘Open the Doors’ garnered 
                                            43 million YouTube views, going viral along the way. Both 
                                            commercials aired to millions of viewers on regional satellite 
                                            and local TV networks.<br />And given exceptional times require exceptional measures, 
                                            both the Ramadan and Eid films were shot using 
                                            unconventional production methods. Every available 
                                            technology was used, 
                                        </p>
                                    </div>
                                    <div class="col-md-6">
                                        <p> from video conferencing to messaging, making it possible to create and supervise 
                                            the production in Kuwait and Saudi Arabia, shoot in Egypt, 
                                            direct from Kuwait and Lebanon, with Bahrain, Iraq, and 
                                            Jordan lending valuable support. All this ensured the films 
                                            received tailor-made footage, instead of resorting to stock 
                                            footage, adding to the authenticity and impact of the films, 
                                            and preserving Zain brand standards.<br/>
                                            The strength of the Zain brand is further reflected in its 
                                            growing and loyal social media base where its followers 
                                            across its footprint number over 23 million, with Zain’s 
                                            Facebook fan base across all operations counting over 12 
                                            million followers; Twitter 7.2 million; Instagram 2.2 million; 
                                            and LinkedIn 600,000. Zain’s YouTube channels rack up 
                                            approximately 100 million views annually.<br/>
                                            Zain’s numerous initiatives across operations have all 
                                            contributed to the reinforcement of the Zain brand’s promise 
                                            and business ethos. The company aspires to unlock 
                                            opportunities for customers and for the communities it 
                                            serves, remaining wholeheartedly committed to the region’s 
                                            economic and social prosperity.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Muddusar Last Sections -->
      </section>
  </div>
</template>

<script>
import locomotiveScroll from 'locomotive-scroll';
import "locomotive-scroll/dist/locomotive-scroll.css";
import "@/assets/sccs/commercialcustomer.scss";
export default {
    name:"commercial-customer",
    components:{
        locomotiveScroll
    },
    data(){
        return{
            scrollSettings: {
                maxHeight: 100,
            }
        }
    },
    methods:{
        scroll(){
            let innerWidth = window.innerWidth;
            let allsection = document.querySelectorAll('.section');
            for (let i = 0; i < allsection.length; i++) {
                const element = allsection[i];
               
                element.style.minWidth = `${innerWidth}px`;
                //`${innerWidth}px`;
            }
            
        },
        noOverFlow(){
                document.querySelector('body').classList.add('light-Slide')
                let $window_width = window.innerWidth;
                
                if ($window_width<=991){
                    document.querySelector('body').classList.add('no-overFlow')
                    
                }
                else{
                    document.querySelector('body').classList.remove('no-overFlow')
                }
        }
    },
    mounted(){
       this.scroll()
       this.imageAnimation()
       this.noOverFlow()
       this.lmS = new locomotiveScroll({
            el: document.querySelector('[data-scroll-container]'),
            smooth: true ,
            direction:"horizontal"
        })
        
    }
}
</script>
<style lang="scss">
    [data-page="commercial-customer"]{
        .verticalLabel{
            background: rgb(248, 247, 247);
            // right: 20px;
        }
        @media screen and (max-width:991px){
            overflow-x: hidden;
        }
    }
</style>
